export const RETRIEVE_EQR_ACCOUNTS = 'RETRIEVE_EQR_ACCOUNTS';
export const SELECT_EQR_ACCOUNT = 'SELECT_EQR_ACCOUNT';
export const EQR_ACCOUNT_CHOSEN = 'EQR_ACCOUNT_CHOSEN';
export const EQR_SUBMISSIONS_RETRIEVED = 'EQR_SUBMISSIONS_RETRIEVED';
export const SET_EQR_SUBMISSIONS_PAGE_SIZE = 'SET_EQR_SUBMISSIONS_PAGE_SIZE';
export const EQR_SUBMISSION_UPDATED = 'EQR_SUBMISSION_UPDATED';